(function() {
    'use strict';

    angular
        .module('app')
        .controller('myTrainingExteriorTimeModalController', myTrainingExteriorTimeModalController);

    function myTrainingExteriorTimeModalController($rootScope, $scope, $uibModalInstance, modalService, $q, saveList) {
        var vm = this;
        vm.ok = ok;
        vm.removeClassRange = removeClassRange;
        vm.saveAndNext = saveAndNext;
        vm.cancel = cancel;
        vm.tabDayOfMonth = tabDayOfMonth;
        vm.tabDayOfWeek = tabDayOfWeek;
        vm.openTimeSelector = openTimeSelector;
        //====Main====
        onInit();
        //============
        function dataInit() {
            //有空維護請將本頁面所使用到全部變數放置這裡視為宣告
            vm.checkView = {
                classDateValid: false,
                classTimeValid: false,
                LunchTimeValid: false,
                weekDayValid: false,
                formSubmited: false,
            };
            vm.data = {
                times: [],
                hours: [
                    '06', '07', '08', '09', '10', '11', '12', '13', '14',
                    '15', '16', '17', '18', '19', '20', '21', '22', '23',
                    '00', '01', '02', '03', '04', '05',
                ],
                mins: [
                    '00', '05', '10', '15', '20', '25',
                    '30', '35', '40', '45', '50', '55'
                ],
                cycleTypeList: [{
                        value: 'week',
                        name: $rootScope.translate.tsunWeek || 'Week',
                    },
                    {
                        value: 'month',
                        name: $rootScope.translate.tsunMonth || 'Month',
                    },
                    {
                        value: 'year',
                        name: $rootScope.translate.tsunYear || 'Year',
                    }
                ],
                weekdays: {
                    '1': {
                        name: $rootScope.translate.tsunWeekMonday || 'Monday',
                        checked: false
                    },
                    '2': {
                        name: $rootScope.translate.tsunWeekTuesday || 'Tuesday',
                        checked: false
                    },
                    '3': {
                        name: $rootScope.translate.tsunWeekWednesday || 'Wednesday',
                        checked: false
                    },
                    '4': {
                        name: $rootScope.translate.tsunWeekThusday || 'Thusday',
                        checked: false
                    },
                    '5': {
                        name: $rootScope.translate.tsunWeekFriday || 'Friday',
                        checked: false
                    },
                    '6': {
                        name: $rootScope.translate.tsunWeekSaturday || 'Saturday',
                        checked: false
                    },
                    '0': {
                        name: $rootScope.translate.tsunWeekSunday || 'Sunday',
                        checked: false
                    },
                },
                cycleList: [{
                    value: 1,
                    name: '1'
                        // name: $rootScope.translate.tsunNumberOne || '一'
                }, {
                    value: 2,
                    name: '2'
                }, {
                    value: 3,
                    name: '3'
                }, {
                    value: 4,
                    name: '4'
                }, {
                    value: 5,
                    name: '5'
                }, {
                    value: 6,
                    name: '6'
                }, {
                    value: 7,
                    name: '7'
                }, {
                    value: 8,
                    name: '8'
                }, {
                    value: 9,
                    name: '9'
                }, {
                    value: 10,
                    name: '10'
                }],
                cycleValue: null,
                cycleType: null,
                hasRestTime: null,
                classDateStart: null,
                classDateEnd: null,
                sessionTimeStartHour: null,
                sessionTimeStartMin: null,
                sessionTimeEndHour: null,
                sessionTimeEndMin: null,
                restTimeStartHour: null,
                restTimeStartMin: null,
                restTimeEndHour: null,
                restTimeEndMin: null,
                saveList: saveList || [],
            };
        }

        function onInit() {
            //若要看手機環境請將此參數改成True
            vm.isMobile = modalService.isMobile();

            dataInit();
            clearPageData();
        }

        function tabDayOfMonth() {
            vm.data.week = undefined;
            vm.data.cycleWeek = undefined;
        }

        function tabDayOfWeek() {
            vm.data.day = undefined;
        }

        function ok() {
            vm.checkView.formSubmited = true;
            if (!vm.data.classDateStart && !vm.data.classDateEnd && vm.data.saveList.length > 0) {
                //若無日期設定視為空值
                $uibModalInstance.close(vm.data.saveList);
                return;
            }
            if (!checkFormData()) { return; }
            return $q.when(pushDataToStore()).then(function() {
                $uibModalInstance.close(vm.data.saveList);
            });
        }

        function saveAndNext() {
            vm.checkView.formSubmited = true;
            if (!checkFormData()) { return; }
            return $q.when(pushDataToStore()).then(function() {
                clearPageData();
                vm.checkView.formSubmited = false;
                // console.log("vm.data.saveList", vm.data.saveList);
            });
        }

        function pushDataToStore() {
            // console.log("enter pushDataToStore");
            var singleData = {
                cycleValue: null,
                cycleType: null,
                hasRestTime: null,
                classDateStart: null,
                classDateEnd: null,
                sessionTimeStartHour: null,
                sessionTimeStartMin: null,
                sessionTimeEndHour: null,
                sessionTimeEndMin: null,
                restTimeStartHour: null,
                restTimeStartMin: null,
                restTimeEndHour: null,
                restTimeEndMin: null,
                showText: "",
                selectWeekday: [],
                innerDataDate: [],
                innerDataTime: []
            };
            var selectedWeekDayText = '';
            var classDateStartDate;
            var classDateEndDate;
            var cycleTimes = 0;
            var classDateStart;
            var classDateEnd;
            var classTime = [];
            _.forEach(singleData, function(value, key) {
                // console.log("key:", key, "value:", vm.data[key]);
                if (vm.data[key] === undefined) { return; }
                singleData[key] = angular.copy(vm.data[key]);
            });
            _.forEach(vm.data.weekdays, function(value, key) {
                if (!value.checked) { return; }
                singleData.selectWeekday.push(parseInt(key));
            });
            classDateStart = Date.parse(singleData.classDateStart);
            classDateEnd = Date.parse(singleData.classDateEnd);
            classDateStartDate = new Date(classDateStart);
            classDateEndDate = new Date(classDateEnd);
            if (!singleData.hasRestTime) {
                classTime = [
                    format("{0}:{1}-{2}:{3}", singleData.sessionTimeStartHour, singleData.sessionTimeStartMin, singleData.sessionTimeEndHour, singleData.sessionTimeEndMin)
                ];
            } else {
                classTime = [
                    format("{0}:{1}-{2}:{3}", singleData.sessionTimeStartHour, singleData.sessionTimeStartMin, singleData.restTimeStartHour, singleData.restTimeStartMin),
                    format("{0}:{1}-{2}:{3}", singleData.restTimeEndHour, singleData.restTimeEndMin, singleData.sessionTimeEndHour, singleData.sessionTimeEndMin),
                ];
            }
            for (var date = new Date(classDateStart); date <= classDateEnd; date.setDate(date.getDate() + 1)) {
                var cycleCompareValue;
                var cycleBaseValue;
                switch (singleData.cycleType.type) {
                    case 'week':
                        cycleBaseValue = Math.floor(classDateStartDate.getDate() / 7);
                        cycleCompareValue = Math.floor(date.getDate() / 7);
                        break;
                    case 'month':
                        cycleBaseValue = classDateStartDate.getMonth();
                        cycleCompareValue = date.getMonth();
                        break;
                    case 'year':
                        cycleBaseValue = classDateStartDate.getFullYear();
                        cycleCompareValue = date.getFullYear();
                        break;
                    default:
                        cycleBaseValue = 0;
                        cycleCompareValue = 0;
                        break;

                }
                // console.log("cycleCompareValue", cycleCompareValue);
                // console.log("cycleBaseValue", cycleBaseValue);
                // console.log("singleData.cycleValue.value", singleData.cycleValue.value);
                cycleTimes = cycleCompareValue - cycleBaseValue;
                if (cycleTimes % singleData.cycleValue.value !== 0) { continue; }
                if (singleData.selectWeekday.indexOf(date.getDay()) < 0) { continue; }
                //==========
                var dateString = '';
                var dateYear = date.getFullYear() + '';
                var dateMonth = (date.getMonth() + 1) + '';
                var dateDay = date.getDate() + '';
                dateString += dateYear.length < 2 ? '0' : '' + dateYear;
                dateString += '/' + (dateMonth.length < 2 ? '0' : '') + dateMonth;
                dateString += '/' + (dateDay.length < 2 ? '0' : '') + dateDay;
                for (var classTimeIndex = 0; classTimeIndex < classTime.length; classTimeIndex++) {
                    singleData.innerDataDate.push(dateString);
                    singleData.innerDataTime.push(classTime[classTimeIndex]);
                }
                // _.forEach(classTime, function (value) {
                // });
            }

            // var classDateStartDate;
            // var classDateEndDate;
            singleData.showText += format("{0}/{1}{2}/{3}{4}", classDateStartDate.getFullYear(), (classDateStartDate.getMonth() < 9 ? "0" : ""), (classDateStartDate.getMonth() + 1), (classDateStartDate.getDate() < 10 ? "0" : ""), classDateStartDate.getDate());
            singleData.showText += format("~{0}/{1}{2}/{3}{4}", classDateEndDate.getFullYear(), (classDateEndDate.getMonth() < 9 ? "0" : ""), (classDateEndDate.getMonth() + 1), (classDateEndDate.getDate() < 10 ? "0" : ""), classDateEndDate.getDate());


            selectedWeekDayText = '';
            if (singleData.selectWeekday.length < 7) {
                _.forEach(singleData.selectWeekday, function(value) {
                    if (selectedWeekDayText.length > 0) { selectedWeekDayText += ','; }
                    selectedWeekDayText += vm.data.weekdays[value].name;
                });
                selectedWeekDayText = format("<span style='word-break:break-word;'>({0})</span>", selectedWeekDayText);
            }

            if (singleData.cycleValue.value > 1) {
                singleData.showText += "<br/>";
                singleData.showText += format("<span>{0} {1} {2}:</span>{3}",
                    $rootScope.translate.commonEvery,
                    singleData.cycleValue.name,
                    singleData.cycleType.name.toLowerCase(),
                    selectedWeekDayText);
            } else if (selectedWeekDayText.length > 0) {
                singleData.showText += "<br/>";
                singleData.showText += selectedWeekDayText;
            }


            singleData.showText += format("<br/>{0}:{1}-{2}:{3}", singleData.sessionTimeStartHour, singleData.sessionTimeStartMin, singleData.sessionTimeEndHour, singleData.sessionTimeEndMin);
            if (singleData.hasRestTime) {
                singleData.showText += format("<br/>{0}:{1}:{2}-{3}:{4}", "午休", singleData.restTimeStartHour, singleData.restTimeStartMin, singleData.restTimeEndHour, singleData.restTimeEndMin);
            }

            // console.log("singleData", singleData);
            vm.data.saveList.push(singleData);
            // console.log("end pushDataToStore");
        }

        function clearPageData() {
            vm.data.cycleValue = vm.data.cycleValue = vm.data.cycleList[0];
            vm.data.cycleType = vm.data.cycleType = vm.data.cycleTypeList[0];
            vm.data.hasRestTime = false;
            vm.data.classDateStart = "";
            vm.data.classDateEnd = "";
            vm.data.sessionTimeStartHour = vm.data.hours[0];
            vm.data.sessionTimeStartMin = vm.data.mins[0];
            vm.data.sessionTimeEndHour = vm.data.hours[0];
            vm.data.sessionTimeEndMin = vm.data.mins[0];
            vm.data.restTimeStartHour = vm.data.hours[6];
            vm.data.restTimeStartMin = vm.data.mins[0];
            vm.data.restTimeEndHour = vm.data.hours[7];
            vm.data.restTimeEndMin = vm.data.mins[0];
            _.forEach(vm.data.weekdays, function(value) {
                value.checked = true;
            });
            // console.log("clearPageData , vm.data:", vm.data);
        }

        function checkFormData() {
            // console.log("enter checkFormData , vm.data:", vm.data);
            var result = false;
            var classDateStart = Date.parse(vm.data.classDateStart); // 
            var classDateEnd = Date.parse(vm.data.classDateEnd);
            var calssTimeStart = new Date("2000", "01", "01", vm.data.sessionTimeStartHour, vm.data.sessionTimeStartMin, "00");
            var calssTimeEnd = new Date("2000", "01", "01", vm.data.sessionTimeEndHour, vm.data.sessionTimeEndMin, "00");
            var isClassLunchTime = vm.data.hasRestTime;
            var classLunchTimeStart = new Date("2000", "01", "01", vm.data.restTimeStartHour, vm.data.restTimeStartMin, "00");
            var classLunchTimeEnd = new Date("2000", "01", "01", vm.data.restTimeEndHour, vm.data.restTimeEndMin, "00");
            // var cycleType = vm.data.cycleType;
            // var cycleValue = vm.data.cycleValue;
            vm.checkView.classDateValid = false;
            vm.checkView.classTimeValid = false;
            vm.checkView.LunchTimeValid = false;
            vm.checkView.weekDayValid = false;
            if (classDateStart && classDateEnd) {
                //驗證上課日期
                vm.checkView.classDateValid = (classDateEnd >= classDateStart);
            }
            if (calssTimeStart && calssTimeEnd) {
                //驗證上課時間
                vm.checkView.classTimeValid = (calssTimeEnd > calssTimeStart);
            }
            if (!isClassLunchTime) {
                vm.checkView.LunchTimeValid = true;
            } else if (classLunchTimeStart && classLunchTimeEnd) {
                //驗證午休
                vm.checkView.LunchTimeValid = (classLunchTimeEnd > classLunchTimeStart) || !isClassLunchTime;
            }
            if (vm.checkView.LunchTimeValid && isClassLunchTime) {
                //驗證午休與上課時間
                vm.checkView.LunchTimeValid = (calssTimeEnd >= classLunchTimeEnd) && (classLunchTimeStart >= calssTimeStart);
            }
            //驗證上課日
            var selectWeekday = [];
            _.forEach(vm.data.weekdays, function(value, key) {
                if (value.checked) {
                    selectWeekday.push(parseInt(key));
                }
            });
            for (var date = new Date(classDateStart); date <= classDateEnd; date.setDate(date.getDate() + 1)) {
                if (vm.checkView.weekDayValid) { break; }
                if (selectWeekday.indexOf(date.getDay()) >= 0) {
                    vm.checkView.weekDayValid = true;
                }
            }

            result =
                vm.checkView.classDateValid &&
                vm.checkView.classTimeValid &&
                vm.checkView.LunchTimeValid &&
                vm.checkView.weekDayValid;

            if (result === false) {
                toastr.warning($rootScope.translate.tsunErrorExteriorTimeEmpty);
            }
            return result;
        }

        function removeClassRange(index) {
            var confirmDialog = modalService.confrimDialog({
                confirmContent: format("{0}\r\n{1}", $rootScope.translate.tsunConfirmRemove, ""),
            });
            confirmDialog.result.then(function(result) {
                result = !!result;
                if (result !== true) {
                    return;
                }
                vm.data.saveList.splice(index, 1);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function openTimeSelector(type, title) {
            var data = null;
            var isCycle=false;
            switch (type) {
                case 'sh': //小時
                case 'eh':
                case 'rsh':
                case 'reh':
                    data = vm.data.hours;
                    break;
                case 'sm': //分鐘
                case 'em':
                case 'rsm':
                case 'rem':
                    data = vm.data.mins;
                    break;
                case 'c': //循環週期
                    data = vm.data.cycleList;
                    isCycle = true;
                    break;
                case 'u': //循環週期單位
                    data = vm.data.cycleTypeList;
                    isCycle = true;
                    break;
            }
            
            var result = modalService.openOptionSelector(data, title,isCycle);
            console.log('openTimeSelector:',result);
            result.result.then(function(data) {
                switch (type) {
                    case 'sh': //開始小時
                        vm.data.sessionTimeStartHour = data;
                        break;
                    case 'eh': //結束小時
                        vm.data.sessionTimeEndHour = data;
                        break;
                    case 'sm': //開始分鐘
                        vm.data.sessionTimeStartMin = data;
                        break;
                    case 'em': //結束分鐘
                        vm.data.sessionTimeEndMin = data;
                        break;
                    case 'rsh': //休息開始小時
                        vm.data.restTimeStartHour = data;
                        break;
                    case 'reh': //休息結束小時
                        vm.data.restTimeEndHour = data;
                        break;
                    case 'rsm': //休息開始分鐘
                        vm.data.restTimeStartMin = data;
                        break;
                    case 'rem': //休息結束分鐘
                        vm.data.restTimeEndMin = data;
                        break;
                    case 'c': //循環週期
                        //vm.data.cycleValue.value = data.id;
                        //vm.data.cycleValue.name = data.name;
                        vm.data.cycleValue = data;
                        break;
                    case 'u': //循環週期單位
                        //vm.data.cycleType.value = data.id;
                        //vm.data.cycleType.name = data.name;
                        vm.data.cycleType = data;
                        break;
                }
            });
        }
    }
})();